// const saveCashBook = async (data) => {
//   const ApiURL = window.Links.ApiURL
//   const authToken = localStorage.getItem("authToken")

//   var myHeaders = new Headers()
//   myHeaders.append("Content-Type", "application/json")
//   myHeaders.append("Authorization", `Bearer ${authToken}`)


//   var requestOptions = {
//     method: "POST",
//     headers: myHeaders,
//     body: data,
//     redirect: "follow",
//   }

//   var data = [];
//   await fetch(`${ApiURL}CashBook`, requestOptions)
//     .then(response => response.json())
//     .then(result => {
//       data = result
//     })
//     .catch(error => console.log('error', error))
//   return data;
// }


const saveCashBook = async (data) => {
  const ApiURL = window.Links.ApiURL;
  const authToken = localStorage.getItem("authToken");

  const myHeaders = new Headers({
    "Content-Type": "application/json",
    "Authorization": `Bearer ${authToken}`,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: data, // Ensure the data is stringified
    redirect: "follow",
  };

  try {
    const response = await fetch(`${ApiURL}CashBook`, requestOptions);
    const responseData = await response.json(); // Directly return the JSON response

    if (responseData.success) {
      return ({ success: true, data: responseData.data, message: responseData.msg });
    }

    return ({ success: false, data: "", message: responseData.msg });


  } catch (error) {
    console.error("Error saving cashbook:", error);
    return ({ success: false, data: "", message: "Error saving cashbook" });
  }
};




export {
  saveCashBook
}


// *** Get and Set values when user click PayMode function API*/

export const PayModetData = async (paymode, cshbookCode, LocationCode) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
    };

    const response = await fetch(`${ApiURL}CashBook/getcashbookdata/${paymode}/${cshbookCode}/${LocationCode}`, requestOptions);
    const responseData = await response.json();

    if (responseData.success && responseData.data) {
      const dataArray = JSON.parse(responseData.data);
      return { success: true, data: dataArray };
    } else {
      return { success: false, data: [] };
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    return { success: false, data: [] };
  }
}

// *** Get and Set values when user click ReasonType function API*/

export const ReasonTypeReceiptsData = async (ref2, cashbookCode, LocationCode) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
    };

    const response = await fetch(`${ApiURL}CashBook/getcashbookreceiptsdata/${ref2}/${cashbookCode}/${LocationCode}`, requestOptions);
    const responseData = await response.json();

    if (responseData.success && responseData.data) {
      const dataArray = JSON.parse(responseData.data);
      return { success: true, data: dataArray };
    } else {
      return { success: false, data: [] };
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    return { success: false, data: [] };
  }
}

// *** End of Get and Set values when user click PayMode function API*/


// *** Get and Set values when user click ReasonType function API*/

export const ReasonTypePaymentsData = async (ref2, cashbookCode, LocationCode) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
    };

    const response = await fetch(`${ApiURL}CashBook/getcashbookpaymentsdata/${ref2}/${cashbookCode}/${LocationCode}`, requestOptions);
    const responseData = await response.json();

    if (responseData.success && responseData.data) {
      const dataArray = JSON.parse(responseData.data);
      return { success: true, data: dataArray };
    } else {
      return { success: false, data: [] };
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    return { success: false, data: [] };
  }
}


export const GetLastCashBookDocument = async (location) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
    };

    const response = await fetch(`${ApiURL}CashBook/getcashbookDocument/${location}`, requestOptions);
    const responseData = await response.json();

    if (responseData.success && responseData.data) {
      return responseData.data
    } else {
      return "";
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    return "";
  }
}


// *** End of Get and Set values when user click PayMode function API*/

const getCashBookData = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var responseData = []
  var requestOptions = {
    method: "GET",
    redirect: "follow",
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  }
  //await fetch(`${ApiURL}common/txntype`, requestOptions)
  await fetch(`${ApiURL}CashBook/SelectCashBook`, requestOptions)
    .then(response => response.json())
    .then(result => {
      responseData = result.data
    })
    .catch(error => console.log("error", error))
  return responseData
}

export { getCashBookData }